module.exports = __webpack_public_path__ + "static/media/parallax-bg.a15ee58d.jpg";